import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const TrainingDrillsTourSteps = [
	{
		selector: '[data-tour="training-page"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDrills.Welcome">
					Welcome to Training Drills. Manage drill folders, create new drills
					and events, and view upcoming or overdue drill sessions.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Tabs">
					Use these tabs to switch between Dashboard, Courses, Drills, Archive,
					and Planner. Dashboard shows the overview here; Courses and Drills
					show detailed session management; Archive lists completed sessions;
					Planner helps schedule training.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-drills-folders"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDrills.Folders">
					Folders and drills — search folders, drills, and events. Use Actions
					to create a new folder or drill. Expand folders to browse drills and
					events; click a drill to view its details and sessions in the right
					panel.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-drills-right"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDrills.Right">
					Drill content — when no drill is selected, this panel shows upcoming
					and overdue drill sessions. Select a drill from the left to see its
					details and sessions. Click a session to view or edit it.
				</Translate>
			</Box>
		),
	},
];
